import React, { useState, useEffect, useRef } from 'react'
import { Activity } from 'lucide-react'
import Cerrar from '../../assets/img/Cerrar.svg'
import { AvatarInitials } from '../../components/AvatarInitials'
import { LoaderNew } from '../../components/LoaderNew'
import { config, formatNumberES } from '../../config'
import TableauReport from 'tableau-react'
import {envVariables} from '../../utils/envVariables/envVariables'
import {getAccessToken} from '../../utils/authSession'
import {savePromotion} from '../../services/save.service'


function getComments(promotionId, productCode) {
	const sessionToken = localStorage.getItem('token')
	// console.log(sessionToken);
	// if there is a session token stored
	if (sessionToken) {
		return fetch(
			envVariables.baseUrl + `/comment/listall/${promotionId}/product/${productCode}`,
			{
				// mode: 'no-cors',
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + sessionToken,
					'Access-Control-Allow-Origin': '*',
					'Access-Control-Allow-Credentials': true,
				},
			}
		)
			.then((response) => {
				if (!response.ok) {
					throw new Error('No fue posible listar comentarios del producto')
				}
				return response.json()
			})
			.then((response) => {
				// console.log(response)
				return response
			})
	}
	return []
}

const normalizeCommentContent = (content) => {
	if (!content) return ''
	try {
		const parsed = JSON.parse(content)
		return typeof parsed === 'string' ? parsed : content
	} catch (error) {
		return String(content).replace(/^"+|"+$/g, '')
	}
}

const resolveAvatarUrl = (value) => {
	if (!value) return ''
	if (/^https?:\/\//i.test(value) || String(value).startsWith('data:')) {
		return value
	}
	return `${envVariables.baseUrl.replace(/\/$/, '')}/${String(value).replace(/^\//, '')}`
}

const getCommentAvatarUrl = (comment) => {
	return resolveAvatarUrl(comment?.url_foto || comment?.avatar_url || '')
}

const buildProductTableauUrl = () => {
	const baseUrl = envVariables.tableauServerBaseUrl?.replace(/\/$/, '')
	const site = envVariables.tableauSite
	const productView = envVariables.tableauViews.vistaproducto

	if (!baseUrl || !site || !productView) return ''

	return `${baseUrl}/t/${site}/views/${productView}`
}

const getMissingProductTableauConfig = () => {
	const requiredConfig = [
		['REACT_APP_TABLEAU_SERVER_BASE_URL', envVariables.tableauServerBaseUrl],
		['REACT_APP_TABLEAU_SITE', envVariables.tableauSite],
		['REACT_APP_TABLEAU_TRUST_URL', envVariables.tableauTrustUrl],
		['REACT_APP_TABLEAU_PRODUCT_PROJECT', envVariables.tableauProductProject],
		['REACT_APP_TABLEAU_PRODUCT_PAGE', envVariables.tableauProductPage],
		['REACT_APP_TABLEAU_VIEW_VISTA_PRODUCTO', envVariables.tableauViews.vistaproducto],
	]

	return requiredConfig.filter(([, value]) => !value).map(([key]) => key)
}

export const CodigoPopNew = ({
	setCodigoPop,
	dataProduct,
	data = null,
	categoria = null,
	subcategoria = null,
	idPromocion,
	promotion,
	saveCatalogBeforeComment = null,
	tradicional = false,
}) => {
	console.log('Data producto vista producto ----------')
	console.log(dataProduct)
	console.log('Data general vista producto')
	console.log(data)
	const [TextareaFocus, setTextareaFocus] = useState(false)
	const [disableCheck, setdisableCheck] = useState(true)
	const [dataView, setDataView] = useState(null)
	const [dataComments, setDataComments] = useState(null)
	const [tokenTableau, setTokenTableau] = useState(null)
	const [tableauError, setTableauError] = useState('')
	const [loader, setLoader] = useState(false)
	const [flag, setFlag] = useState(false)
	const [hasFetched, setHasFetched] = useState(false);
	const initialized = useRef(false)
	const currentUserName = `${localStorage.getItem('nameUser') || ''} ${
		localStorage.getItem('lastName') || ''
	}`.trim()
	const currentUserPhoto = localStorage.getItem('url_foto') || localStorage.getItem('avatar_url') || ''
	const productTableauUrl = buildProductTableauUrl()
	const productTableauMissingConfig = getMissingProductTableauConfig()
	const parameters_ = {
		"Codigo Producto": [dataProduct.codigo_producto],
		"cadena": [promotion.data_promocion.nombre_cadena]
	}
	const emptyProductInfoMessage =
		'No existe información disponible para este producto por ahora. Estamos trabajando para solucionarlo.'

	const refCatalogModern = useRef(null)

	function getViewProduct(
		codeProduct,
		customer,
		type = null,
		promotionId = null
	) {
		const sessionToken = localStorage.getItem('token')
		// if there is a session token stored
		setLoader(true)
		if (sessionToken) {
			let urlBase = ``
			if (type === 'tradicional') {
				if (dataProduct.office_code !== null) {
					urlBase = `/productos/view/${codeProduct}/customer/${customer.toUpperCase()}`
				} else {
					urlBase = `/productos/view/${codeProduct}/customer/${customer.toUpperCase()}`
				}
				console.log('url', config.apiUrl + urlBase)
			} else {
				urlBase = `/productos/view/${codeProduct}/customer/${customer.toUpperCase()}`
			}
			return fetch(config.apiUrl + urlBase, {
				method: 'GET',
				// mode: 'no-cors',
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + sessionToken,
					'Access-Control-Allow-Origin': '*',
					'Access-Control-Allow-Credentials': true,
					'method': 'POST',
				},
			})
				.then((response) => {
					if (response.ok) {
						return response.json()
					}
				})
				.then((response) => {
					setLoader(false)
					return response
				})
				.catch((error) => {
					setLoader(false)
					console.log('err::: ', error)
				})
		}
	}

	const isEmptyProductInfo = (productInfo) => {
		if (!productInfo) return true
		if (Array.isArray(productInfo)) return productInfo.length === 0
		if (typeof productInfo === 'object') return Object.keys(productInfo).length === 0
		return false
	}

	useEffect(() => {
		document.addEventListener('click', closeModal, true)
	}, [])

	const closeModal = (e) => {
		if (!refCatalogModern.current.contains(e.target)) {
			setCodigoPop(false)
		}
	}

		console.log("promotion:::::::::")
		console.log(promotion)
	

	const fetchApi = async () => {
		if (productTableauMissingConfig.length) {
			setTableauError(`Configuración de Tableau incompleta. Faltan: ${productTableauMissingConfig.join(', ')}`)
			return
		}

		try {
			const response = await fetch(envVariables.tableauTrustUrl, {
				method: 'POST',
				body: JSON.stringify({
					token: getAccessToken() + '-2chzRY3F3I9@',
					tabs_permission: envVariables.tableauTabsPermission,
					dtarget_site: envVariables.tableauSite,
					project: envVariables.tableauProductProject,
					page: envVariables.tableauProductPage,
				}),
			})
			console.log("respuesta tableau server::::::::::::::::::.")
			console.log(response.status)
			console.log(response)
			const responseJSON = await response.json()
			setTokenTableau(responseJSON.token_server)
		} catch (error) {
			console.error(error)
			setTableauError('No fue posible cargar la configuración de Tableau.')
		}
	}

	useEffect(() => {
		if (!initialized.current) {
			fetchApi();
			initialized.current = true
		  }
	}, [])

	useEffect(() => {		
			getViewProduct(
				dataProduct.codigo_producto,
				promotion.data_promocion.nombre_cadena
			)
				.then((result) => {
					if (isEmptyProductInfo(result)) {
						alert(emptyProductInfoMessage)
						setCodigoPop(false)
						return
					}
					setDataView(result)
				})
				.catch((err) => {
					alert(emptyProductInfoMessage)
					setCodigoPop(false)
					console.error(err)
				})
		
	}, [])


	useEffect(() => {
		getComments(idPromocion, dataProduct.codigo_producto).then((result) => {
			setDataComments(result)
			setFlag(false)
		}).catch((error) => {
			console.log(error)
			setDataComments([])
			setFlag(false)
		})
		
	}, [flag, idPromocion, dataProduct.codigo_producto]) 

	const Callback = async () => {
		const inputComment = document.getElementById('input_comment')
		const comment = inputComment.value
		const sessionToken = localStorage.getItem('token')
		if (!comment.trim()) {
			inputComment.disabled = false
			return
		}
		if (sessionToken) {
			try {
				if (saveCatalogBeforeComment) {
					await saveCatalogBeforeComment()
				} else {
					await savePromotion(idPromocion, promotion)
				}

				const response = await fetch(envVariables.baseUrl + `/comment/product/create`, {
					// mode: 'no-cors',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: 'Bearer ' + sessionToken,
						'Access-Control-Allow-Origin': '*',
						'Access-Control-Allow-Credentials': true,
					},
					body: JSON.stringify(
						{
							promotion_id: parseInt(idPromocion),
							product_code: String(dataProduct.codigo_producto),
							comment: comment,
						},
					),
				})

				if (!response.ok) {
					throw new Error('No fue posible crear el comentario del producto')
				}

				await response.json()
				inputComment.value = ''
				inputComment.disabled = false
				setdisableCheck(true)
				setFlag(true)
			} catch (error) {
				console.log(error)
				alert("No fue posible guardar el catálogo y crear el comentario. Intenta nuevamente.");
				inputComment.disabled = false
			}
		} else {
			inputComment.disabled = false
		}
	}

	const renderCommentRow = (EachRow) => {
		const isProductComment = EachRow.notification_type === 6
		const author = EachRow.commented_by || ''
		const phase = [
			EachRow.promotional_promotional_phase,
			EachRow.promotional_promotional_phase_state,
		].filter(Boolean).join(' | ')
		const date = EachRow.commented_at || ''
		const content = normalizeCommentContent(EachRow.content)
		const activity = EachRow.activity || content

		return isProductComment ? (
			<div className='profile_box responder' key={EachRow.id}>
				<AvatarInitials name={author} size={20} src={getCommentAvatarUrl(EachRow)} />
				<div className='presentation'>
					<div className='top_area'>
						<h1>{author}</h1>
						<p>{phase && phase + ' | '} {date}</p>
					</div>
					<input
						type='text'
						placeholder={content}
						value={content}
						readOnly
					/>
				</div>
			</div>
		) : (
			<div
				key={EachRow.id}
				className='profile_box'
				id={'box_comment_' + EachRow.id}
				style={{ marginBottom: '10px' }}
			>
				<AvatarInitials name={author} size={20} src={getCommentAvatarUrl(EachRow)} />
				<div className='presentation'>
					<div className='top_area'>
						<h1>{author}</h1>
					</div>
					<div className='middle_area'>
						<p>
							{activity}
							<span></span>
						</p>
					</div>
					<p>
						{phase && phase + ' | '} {date}
					</p>
				</div>
			</div>
		)
	}

	const onEnter = (event) => {
		if (event.key === 'Enter') {
			document.getElementById('input_comment').disabled = true
			Callback()
		}
	}

	const getStrMonth3 = (monthStr) => {
		const montshObj = {
			Jan: '01',
			Feb: '02',
			Mar: '03',
			Apr: '04',
			May: '05',
			Jun: '06',
			Jul: '07',
			Aug: '08',
			Sep: '09',
			Oct: '10',
			Nov: '11',
			Dec: '12',
		}
		return montshObj[monthStr]
	}

	// const arrAuxMapeName = [
	// 	dataView?.mape_winner_name,
	// 	...dataView.other_mape_names,
	// ]
	// const arrAuxMapeValues = [dataView?.mape, ...dataView?.other_mape_values]

	return (
		<div className='popupWrapper OfertaWrapper TottusPop CodigoPop'>
			{ /* loader && <LoaderNew message={'Cargando...'} /> */ }
			
			{!loader && (
				<div className='popup' ref={refCatalogModern} style={{
					// width: "1600px"
					}}>
					<div
						className='close_icon'
						onClick={(e) => {
							setCodigoPop(false)
						}}
					>
						<img
							src={Cerrar}
							alt=''
							onClick={(e) => {
								setCodigoPop(false)
							}}
						/>
					</div>
					<div className='left_side' style={{
						// width: "400px"
						}}>
						<h1>
							<svg
								width='24'
								height='24'
								viewBox='0 0 24 24'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<mask
									id='mask0_2505_117424'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='24'
									height='24'
								>
									<rect width='24' height='24' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_2505_117424)'>
									<path
										d='M2 6H3.83299V19H2V6ZM7.45825 6H8.35438V19H7.45825V6ZM4.72912 6H6.56212V19H4.72912V6ZM19.2709 6H22V19H19.2709V6ZM10.1874 6H11.9796V19H10.1874V6ZM16.5418 6H17.4379V19H16.5418V6ZM12.9165 6H15.6456V19H12.9165V6Z'
										fill='#AEB0B0'
									/>
								</g>
							</svg>
							{dataProduct.codigo_producto}
							<p className='special_p'>{dataProduct.descripcion}</p>
						</h1>

						<table>
							<tbody>
								<tr>
									<td>
										<p>Familia</p>
										<h1>{dataView && dataView.familia}</h1>
									</td>
									<td>
										<p>Sub Familia</p>
										<h1>
										{dataView && dataView.subfamilia}
										</h1>
									</td>
									<td className='border-gray' width='12%'>
										<p>Marca</p>
										<h1>{dataView && dataView.marca}</h1>
									</td>
									<td>
										<p>Peso Caja</p>
										<h1>{dataView && dataView.peso} g</h1>
									</td>
									{ /*
									<td>
										<p>Peso Unidad</p>
										<h1>{dataView && dataView.um}</h1>
									</td> 
									<td width='5%'>
										<p>Und</p>
										<h1>{dataView && dataView.stock_und}</h1>
									</td>
									<td width='5%'>
										<p>Vol.</p>
										<h1>{dataView && dataView.stock_kg}</h1>
									</td> */ }
									<td> 
										<p>Formato Venta</p>
										<h1>{dataView && dataView.um}</h1>
									</td>
								</tr>
								<tr>
									<td>
										<p>
											Costo <br /> Direc.
										</p>
										<h1>${dataView && dataView.costo_x_kg} (Kg)</h1>
									</td>
									<td>
										<p>
											Cto. <br /> Proyec.
										</p>
										<h1>
											${dataView && dataView.costo_proyectado_kg} (Kg)
										</h1>
									</td>
									
										<td>
											<p style={{ height: '30px' }}>Salas</p>
											<h1>{dataView &&  dataView?.salas}</h1>
										</td>
									
									{ /*
										<td width='12%'
										style={{
											display: 'flex',
											flexDirection: 'column',
											justifyContent: 'space-between',
											height: '60px',
										}}
										>
											<p>Catalogación</p>
											<h1><br></br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{dataView &&  dataView?.catalogacion}</h1>
										</td>
									*/ }

									
										
									
									
										<td>
											<p>
												Crec. <br /> Interanual
											</p>
											<h1>{dataView && dataView?.crec_interanual}</h1>
										</td>
									
									
									<td>
										<p>
											Días <br /> Inventario
										</p>
										<h1>{dataView?.dias_inventario}</h1>
									</td>
								</tr>
							</tbody>
						</table>

						

						<h1 style={{ marginTop: 20 }}>
							<Activity size={16} color="#AEB0B0" />
							Actividad
						</h1>

						<div className='profile_box_wrapper profile_box_wrapperNew'>
							<div className='profile_box' style={{ alignItems: 'flex-start' }}>
								<AvatarInitials name={currentUserName} src={currentUserPhoto} />
								<div className='presentation' style={{ position: 'relative' }}>
									<textarea
										cols='30'
										rows='10'
										className={`${TextareaFocus && 'messageType'}`}
										placeholder='Escribe un comentario...'
										onChange={(e) => {
											if (e.target.value !== '') {
												setdisableCheck(false)
											} else {
												setdisableCheck(true)
											}
										}}
										onFocus={(e) => {
											setTextareaFocus(true)
										}}
										onBlur={(e) => {
											setTextareaFocus(false)
										}}
										onKeyPress={(e) => onEnter(e, 1)}
										id='input_comment'
										autoComplete='off'
										defaultValue={"Comentario producto "+dataProduct.codigo_producto+": "}
									></textarea>
									{/* <button className="comment" disabled={disableCheck} 
                    onClick={(e) => {Callback()}}>
                    Comentar
                  </button> */}
								</div>
							</div>

							<div id='section_comments' className='commentsMax'
						style={{height: '450px', maxHeight: '450px', 
						overflowX: "auto"}}>
							{
							!dataComments
								? ''
								: [...dataComments]
									.sort((a,b) => b.id - a.id)
									.map((EachRow) => renderCommentRow(EachRow))}
						</div>
						</div>
					</div>
					<div className='right_side' style={{
						// width: "800px",  
						background: 'transparent'
						}}>
						<div className='gray_area' style={{ background: 'transparent' }}>
							{tableauError ? (
								<div style={{padding: '24px', color: '#474747'}}>{tableauError}</div>
							) : !tokenTableau ? (
								'Cargando Dashboard...'
							) : (
								/*
								<TableauReport
									url={productTableauUrl}
									token={tokenTableau}
									options={{
										width: "100%",
										height: "95vh",
									}}
									query="?:jsdebug=n"
									parameters={parameters_}
								/>
								*/
								<iframe
									src={'/Dashboardclean/'+dataProduct.codigo_producto+'/'+promotion.data_promocion.nombre_cadena}
									width='600'
									height='100%'
									frameBorder='0'
									title='Dashboard'
								></iframe>
							)}
						</div>
					</div>
				</div>
			)}
		</div>
	)
}
